var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.26367C2.25 9.26367 5.4 4.76367 9 4.76367C12.6 4.76367 15.75 9.26367 15.75 9.26367C15.75 9.26367 12.6 13.7637 9 13.7637C5.4 13.7637 2.25 9.26367 2.25 9.26367Z",
    stroke: "#666666",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00078 10.1637C10.4919 10.1637 11.7008 8.95484 11.7008 7.46367C11.7008 5.9725 10.4919 4.76367 9.00078 4.76367C7.50961 4.76367 6.30078 5.9725 6.30078 7.46367C6.30078 8.95484 7.50961 10.1637 9.00078 10.1637Z",
    stroke: "#666666",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.b21e00de0e80a2a202db1119f8e3e34a.svg";
export { ForwardRef as ReactComponent };